import { render, staticRenderFns } from "./OrganizationIpaAddressModal.vue?vue&type=template&id=17f7bf3b&"
import script from "./OrganizationIpaAddressModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationIpaAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports